import type { StateCreator } from "zustand";
import type { PlanType } from "@/repositories/plan/types";
import type { StripeProduct } from "@/repositories/stripe/types";

export interface StripeFormSlice {
  isFormOpen: boolean;
  setIsFormOpen: (isFormOpen: boolean) => void;
  selectedProduct?: StripeProduct | null;
  setSelectedProduct: (product: StripeProduct | null) => void;
  priceId: string | null;
  setPriceId: (priceId: string | null) => void;
  isDowngradeConfirmOpen: boolean;
  setIsDowngradeConfirmOpen: (isOpen: boolean) => void;
  targetPlanType: PlanType | null;
  setTargetPlanType: (planType: PlanType | null) => void;
}
export const createStripeFormSlice: StateCreator<
  StripeFormSlice,
  [["zustand/devtools", never]],
  [],
  StripeFormSlice
> = (set) => ({
  isFormOpen: false,
  setIsFormOpen: (isFormOpen) => set({ isFormOpen }),
  selectedProduct: null,
  setSelectedProduct: (selectedProduct) => set({ selectedProduct }),
  priceId: null,
  setPriceId: (priceId) => set({ priceId }),
  isDowngradeConfirmOpen: false,
  setIsDowngradeConfirmOpen: (isDowngradeConfirmOpen) => set({ isDowngradeConfirmOpen }),
  targetPlanType: null,
  setTargetPlanType: (targetPlanType) => set({ targetPlanType }),
});
